import React, { useState } from 'react'
import { post } from 'aws-amplify/api'

import classes from './Signup.module.css'

import Button from '../../components/UI/Button/Button'
import Input from '../../components/UI/Input/Input'

const Signup = () => {
  const [user, setUser] = useState({})

  const confirmPassword = () => {
    if (!user.password || !user.password) {
      return 'nopass'
    } else if (user.password === user.cpassword) {
      return 'match'
    } else {
      return 'not match'
    }
  }

  const signUp = async () => {
    try {
      const response = post({
        apiName: process.env.REACT_APP_API_BASE_URL,
        path: '/auth/signUp',
        options: {
          headers: {
            'Content-Type': 'application/json'
          },
          body: {
            email: user.email,
            password: user.password,
            username: user.email.split('@')[0]
          }
        }
      })
      const { body } = await response.response
      await body.json()
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div className={classes.Container}>
      <Input
        type=''
        value={user.email}
        onChange={(e) => setUser({ ...user, email: e.target.value })}
        className=''
        label='email'
        autoComplete=''
        maxLength=''
        required=''
      />
      <Input
        type='password'
        value={user.password}
        onChange={(e) => setUser({ ...user, password: e.target.value })}
        className=''
        label='passowrd'
        autoComplete=''
        maxLength=''
        required=''
      />
      <Input
        type='password'
        value={user.cpassword}
        onChange={(e) => setUser({ ...user, cpassword: e.target.value })}
        className=''
        label='confirm password'
        autoComplete=''
        maxLength=''
        required=''
      />
      <div>
        <Button
          disabled={confirmPassword() !== 'match'}
          onClick={() => signUp()}
        >
          Sign Up
        </Button>
      </div>
      <div style={{ color: 'red' }}>{confirmPassword()}</div>
    </div>
  )
}

export default Signup
